/** 新设备收益详情页 **/
<template>
  <div class="home">
    <Layout
      type="REVENUE"
      isRevenue="true"
      :pageTitle="$t('menu.revenueDetails')"
    >
      <BasiceLayout
        title="新设备收益详情"
        class="revenue-layout"
      >
        <div class="revenue-detail-select">
          <span class="revenue-date-wrap">{{$t('revenueDate')}}:</span>
          <el-select
            v-model="selectDate"
            filterable
            @change="search"
          >
            <el-option
              v-for="item in queryDate"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>
        <el-table
          v-if="rewardList"
          :data="rewardList.slice((currentPage-1)*pagesize,currentPage*pagesize)"
          align="left"
          empty-text="暂无数据"
          style="width: 100%"
        >
          <el-table-column
            prop="mac"
            align='center'
            label="mac"
          >
          </el-table-column>
          <el-table-column
            prop="BP"
            align='center'
            label="BP"
          ></el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pagesize"
          layout="total, prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </BasiceLayout>
    </Layout>
  </div>
</template>

<script>
import Layout from "@/components/DatePanel/Layout.vue";
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import moment from "moment";
import { mapActions, mapState } from "vuex";
import { Message } from "element-ui";

export default {
  name: "home",
  data() {
    return {
      selectDate: moment()
        .utc()
        .startOf("day")
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
      currentPage: 1,
      pagesize:20,
      total:0,
      searchMacAddress: "",
      rewardList: [],
    };
  },
  components: {
    Layout,
    BasiceLayout,
  },
  computed: mapState({
    queryDate: () => {
      let queryDate = [];
      let endDay = moment()
        .utc()
        .startOf("day");

      endDay -= 24 * 60 * 60 * 1000;
      let i = 0;
      while (i < 7) {
        i++;
        queryDate.push(moment(endDay).format("YYYY-MM-DD"));
        endDay -= 24 * 60 * 60 * 1000;
      }
      return queryDate;
    },
  }),
  created() {
    let queryDate = moment()
      .utc()
      .startOf("day")
      .subtract(1, "days")
      .format("YYYY-MM-DD");
    this.queryDate = queryDate;
    this.getRevenueList();
  },
  methods: {
    ...mapActions([ 'getActivityRevenue' ]),
    async getRevenueList() {
      const params = { dateAt: this.selectDate, type:'new' };
      const res = await this.getActivityRevenue(params);
      if(res && res.code === 200 ) {
        this.rewardList = res.rewardList;
        this.total = res.rewardList.length;
      } else {
        this.rewardList = '';
        this.total = 0;
      }
    },
    async search(queryDate) {
      this.queryDate = queryDate;
      this.getRevenueList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
    }
  }
};
</script>

<style lang="stylus">
.data-panel-wrap, .data-panel-layout, .home {
  height: 100%;
}

.revenue-all-layout {
  height: 100%;
}

.revenue-date-wrap {
  margin: 0 20px;
}

.revenue-detail-select {
  text-align: left;
  padding-bottom: 30px;
  margin-bottom: 30px;
  border-bottom: 1px solid #ddd;
}
</style>

<i18n>
  {
  "zn": {
    "revenueDate": "查询日期（UTC）"
  },
  "en": {
    "revenueDate": "Date（UTC）"
  }
}
</i18n>
